<template>
  <div></div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    quote: {
      type: [Object,Boolean],
      default: false,
    },
  },
  data: function () {
    return {}
  }

}
</script>

<style scoped lang="scss">

</style>
